import { useState } from 'react';
import styled from 'styled-components';

import DefaultInput from 'components/input/DefaultInput';

import { color } from 'asserts/styles/colors';

interface EditDataProps {
  text: string;
  setNewData: (newData: string) => void;
  onChangeData: () => void;
  isMypage?: boolean;
}

const EditData = ({ text, isMypage = false, setNewData, onChangeData }: EditDataProps) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [editNewData, setEditNewData] = useState(text);

  const handleClick = () => {
    setIsEditMode((prev) => !prev);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEditNewData(event.target.value);
  };

  const handleSave = () => {
    setNewData(editNewData);
    setIsEditMode(false);

    setTimeout(() => {
      onChangeData();
    }, 0);
  };

  return (
    <Wrapper>
      <TextWrapper $isSaveName={isEditMode}>
        {isEditMode ? <DefaultInput name={text} onChange={handleInputChange} /> : <h6>{text}</h6>}
      </TextWrapper>
      <div>
        {isEditMode ? (
          <ButtonWrapper $isMypage={isMypage}>
            <button onClick={() => handleSave()}>저장</button>
            <button className="cancel" onClick={handleClick}>
              취소
            </button>
          </ButtonWrapper>
        ) : (
          <button onClick={handleClick}>수정</button>
        )}
      </div>
    </Wrapper>
  );
};

export default EditData;

const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  width: max-content;

  div {
    display: flex;
  }

  button {
    color: ${color.black2};
    font-weight: 500;
  }
`;

const TextWrapper = styled.div<{ $isSaveName: boolean }>`
  display: flex;
  height: 36px;
  border: ${(props) => !props.$isSaveName && '1px solid rgba(12, 12, 12, 0.05)'};
  border-radius: 4px;
  align-items: center;
  justify-content: center;

  h6 {
    display: flex;
    width: 132px;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 18px;
  }

  span.ant-input-affix-wrapper {
    width: 119px;
  }
`;

const ButtonWrapper = styled.div<{ $isMypage: boolean }>`
  display: flex;
  gap: ${(props) => (props.$isMypage ? '25px' : '9px')};

  button.cancel {
    position: relative;
    color: ${color.gray500};

    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: ${(props) => (props.$isMypage ? '-50%' : '-4.5px')};
      width: 1px;
      height: 12px;
      background: ${color.gray300};
    }
  }
`;
